import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTButton from "../../_buttons/Button"
import BurgerMenu from "../../_icons/BurgerMenu"
import NRTBackButton from "../../_buttons/BackButton"

class NRTMasterSlave extends Component {

    state = {
        slaveCollapsed: window.innerWidth < 600 ,
    }

    collapseSlave = () => this.setState({slaveCollapsed: true})
    openSlave = () => this.setState({slaveCollapsed: false})


    render() {

        const {
            slaveCollapsed
        } = this.state

        const {
            slaveClassNames,
            onBackButtonClick,
            slaveStyle,
            slaveHeight,
            disableSlaveAction
        } = this.props

        let {
            masterClassNames
        } = this.props


        const slaveCls = slaveCollapsed ? ' slave-closed ' : ' slave-open '
        masterClassNames += slaveCollapsed ? 'menu-closed' : 'menu-open'
        const disabledCls = disableSlaveAction ? ' disable' : ''

        return (
            <div className={'nrt-master-slave-wrapper '}>


                <div className={"overlay " +  slaveCls}
                     onClick={this.collapseSlave}/>


                <div className={'slave ' + slaveClassNames + slaveCls + disabledCls}
                style={slaveStyle}>

                    {
                        onBackButtonClick &&
                        <NRTBackButton onClick={onBackButtonClick}/>
                    }



                    <div className="burger-menu">
                        <NRTButton onClick={this.collapseSlave}
                                   iconButton
                                   outline
                                   noBorder
                            secondary
                        >
                            <BurgerMenu/>
                        </NRTButton>
                    </div>

                    <div className={'slave-content'} style={{
                        height:slaveHeight,
                        maxHeight:'100vh' ,
                    }}>
                    {this.props.slave}
                    </div>
                </div>

                <div className={'master ' + masterClassNames  }>

                    {
                        slaveCollapsed &&
                        <div className="burger-menu">
                            <NRTButton onClick={this.openSlave}
                                       iconButton
                                       outline
                                       noBorder
                            >
                                <BurgerMenu/>
                            </NRTButton>
                        </div>
                    }


                    {this.props.master}
                </div>

            </div>
        )
    }
}


NRTMasterSlave.propTypes = {
    slave: PropTypes.element.isRequired,
    master: PropTypes.element.isRequired,
    slaveStyle: PropTypes.object,
    slaveClassNames: PropTypes.string,
    masterClassNames: PropTypes.string,
    slaveHeight: PropTypes.any,
    onBackButtonClick: PropTypes.func ,
}

NRTMasterSlave.defaultProps = {
    slaveClassNames: '',
    masterClassNames: '',
    slaveStyle: {

    },
    slaveHeight: '100vh'
}

export default NRTMasterSlave



// WEBPACK FOOTER //
// ./src/components/_common/_containers/MasterSlave/index.js